import React from "react";
// Routing
import { Link } from "react-router-dom";

// Styling
import styled from "styled-components";
import { IoCaretBackCircleOutline } from "react-icons/io5";
import { IconContext } from "react-icons";

// import hackowasp from "../images/hacowasp.png";
import dash2 from "../images/logotantra.png";
import dash from "../images/dash.png";
import et from "../images/examtantra.png";
import base from "../images/tantrabase.png";
import bravo from "../images/bravo1.png";
import { motion } from "framer-motion";

// Animations and Scroll
import { pageAnimation, Fade, imageAnimation, FadeLine } from "./Animation";
import { ScrollToTop } from "./ScrollToTop";

const ProjectInfoET = () => {
  return (
    <ProjectContainer variants={pageAnimation} initial="hidden" animate="show">
      <IconContext.Provider
        value={{
          color: "white",
          size: "70px",
          style: { marginLeft: "3rem" },
        }}
      >
        <Link to="/">
          <Logo>
            <motion.h2 variants={Fade}>Chirag Rao</motion.h2>
            <motion.div variants={Fade}>
              <IoCaretBackCircleOutline className="back" />
            </motion.div>
          </Logo>
        </Link>
      </IconContext.Provider>
      <div className="header">
        <motion.h1 variants={FadeLine}>Exam Tantra</motion.h1>
        <motion.h3 variants={Fade}>Gamifying Exams</motion.h3>
        <Hide>
          <motion.img variants={imageAnimation} src={et} alt="et" />
        </Hide>
      </div>
      <div className="content">
        <div className="top">
          <div className="text">
            <motion.h1 variants={FadeLine}>Introduction</motion.h1>
            <motion.p variants={Fade}>
              Competitive Exams provide students with entry into top colleges,
              scholarships, grants, prizes and more.They're also used in the
              selection of military and civil service officers. This makes
              success in these exams very lucrative, attracting many students.
            </motion.p>
          </div>
          <div className="imageflex">
            <Hide>
              <motion.img variants={imageAnimation} src={base} alt="" />
            </Hide>
            <div className="textinner">
              <motion.h3 variants={Fade}>The Problem</motion.h3>
              <motion.p variants={Fade}>
                However the archaic education system makes the preparation
                process very tedious, boring and unintuitive. The sudden rise in
                solutions implementing technology into education is no
                coincidence.
              </motion.p>
            </div>
          </div>
        </div>
        <div className="imageflex1">
          <Hide>
            <motion.img variants={imageAnimation} src={dash2} alt="" />
          </Hide>
          <div className="textinner">
            <motion.h3 variants={Fade}>The Solution?</motion.h3>
            <motion.p variants={Fade}>
              Hence we created ExamTantra. ExamTantra’s by adding elements such
              as peer attempts: solving papers with peers leaderboards to
              compare progress, a clean minimal UI so as to not distract the
              user, badges, awards and other reinforcements which have been
              proven to be psychological motivators. We believe that everyone
              must have the right to a fair education, thus ExamTantra is a free
              app optimized for most devices.
            </motion.p>
          </div>
        </div>
        <ButtonWrapper>
          <motion.button variants={Fade}>
            <a
              style={{ textDecoration: "none", color: "white" }}
              href="https://drive.google.com/file/d/1Va-TlFD3ab7K3gHOzlVY4Z-IFSk7lZKx/view?usp=sharing"
              rel="noopener noreferrer"
              target="_blank"
            >
              Download The APK!
            </a>
          </motion.button>
          {/* <motion.button variants={Fade}>View the PPT</motion.button> */}
          <motion.button variants={Fade}>
            <a
              style={{ textDecoration: "none", color: "white" }}
              href="https://devfolio.co/submissions/examtantra-27f5"
              rel="noopener noreferrer"
              target="_blank"
            >
              View Devfolio
            </a>
          </motion.button>
        </ButtonWrapper>
        <div className="gallery">
          <motion.h1 variants={{ FadeLine }}>Gallery</motion.h1>
          <Hide>
            <motion.img variants={imageAnimation} src={dash} alt="gallery1" />
          </Hide>
          <Hide>
            <motion.img variants={imageAnimation} src={bravo} alt="gallery2" />
          </Hide>
        </div>
      </div>
      <ScrollToTop />
    </ProjectContainer>
  );
};

const Logo = styled(motion.div)`
  position: absolute;
  top: 10px;
  left: 10px;
  font-family: "Lobster";
  font-size: "1rem";
  float: right;
  display: flex;
  align-items: flex-end;
  padding: 0rem 1rem;
  margin: 2rem 0rem;
  .back {
    display: none;
  }
  @media screen and (max-width: 520px) {
    h2 {
      display: none;
    }
    .back {
      display: block;
    }
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-bottom: 7rem;
  a {
    &:hover {
      color: "#ffffff";
    }
  }
`;

const ProjectContainer = styled(motion.div)`
  max-width: 3000px;
  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    flex-wrap: wrap;
    img {
      width: 100%;
      height: 30rem;
      object-fit: contain;
    }
  }
  .content {
    padding: 10px;
    .text {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 1rem 0rem;
      margin: 1rem 0rem 0rem 4rem;
      width: 90%;
    }
    p {
      margin: auto;
    }
  }

  font-family: "Quicksand", sans-serif;
  .gallery {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    h1 {
      width: 70%;
    }
    img {
      width: 1000px;
      margin: 1rem 0rem;
      padding: 1rem 0rem;
    }
  }
  .imageflex {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-wrap: wrap;
    flex-direction: row;
    img {
      width: 500px;
      height: 500px;
      object-fit: contain;
      margin: 0rem 1rem 0rem 0rem;
      margin: 1rem 0rem 0rem 2rem;
    }
    .textinner {
      max-width: 800px;
    }
  }
  .imageflex1 {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-wrap: wrap;
    flex-direction: row-reverse;
    img {
      width: 500px;
      height: 500px;
      object-fit: contain;
      margin: 0rem 1rem 0rem 0rem;
      margin: 1rem 0rem 0rem 2rem;
    }
    .textinner {
      max-width: 800px;
    }
  }

  h1 {
    color: white;
    font-weight: bolder;
    font-size: 3rem;
    padding: 1rem 0rem 2rem 0rem;
    text-align: center;
    color: #23d997;
    border-bottom: 2px solid #23d997;
  }
  h3 {
    color: white;
    font-size: 2rem;
    font-weight: bolder;
    padding: 2rem 0rem 2rem 0rem;
    text-align: center;
  }
  p {
    margin: 4rem 0rem;
    color: white;
    font-size: 2rem;
    padding: 2rem 4rem;
    max-width: 1200px;
  }

  @media screen and (max-width: 520px) {
    img {
      width: 80%;
      height: 60vh;
      margin: 1rem 0rem;
      padding: 1rem 0rem;
    }
    p {
      font-size: 2rem;
    }
    h1 {
      font-size: 4rem;
    }
    h3 {
      font-size: 3.2rem;
    }
  }
`;

const Hide = styled.div`
  overflow: hidden;
`;

export default ProjectInfoET;
